import { aboutApi } from "./about";
import { adminApi } from "./admin";
import { authApi } from "./auth";
import { inventoryApi } from "./inventory";
import { manufacturersApi } from "./manufacturers";
import { ordersApi } from "./orders";
import { sentryApi } from "./sentry";
export { errorMessage } from "./http";

const api = {
    about: aboutApi,
    admin: adminApi,
    auth: authApi,
    inventory: inventoryApi,
    manufacturers: manufacturersApi,
    orders: ordersApi,
    sentry: sentryApi,
};

export type Api = typeof api;

export function useApi(): Api {
    return api;
}
